import { render } from "./SignupModal.vue?vue&type=template&id=08d87c4f&bindings={\"data\":\"setup\",\"modals\":\"setup\",\"success\":\"setup\",\"error\":\"setup\",\"apply\":\"setup\",\"nickname\":\"setup\",\"t\":\"setup\"}"
import script from "./SignupModal.vue?vue&type=script&lang=js"
export * from "./SignupModal.vue?vue&type=script&lang=js"
script.render = render

export default script